import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgSelectModule } from '@ng-select/ng-select';
import { LAZYLOAD_IMAGE_HOOKS, LazyLoadImageModule, ScrollHooks } from 'ng-lazyload-image';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import '../style/warehouse.scss';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BreadcrumbsModule } from './breadcrumbs/breadcrumbs.module';
import { MATERIAL_MOMENT_DATE_FORMATS } from './core/configuration/MATERIAL_MOMENT_DATE_FORMATS';
import { CoreModule } from './core/core.module';
import { SentryErrorHandlerService } from './core/services/sentry-error-handler.service';
import { MikuMenuModule } from './miku-menu/miku-menu.module';
import { SecurityModule } from './security/security.module';
import { TokenInterceptor } from './security/services/token.interceptor';
import { FiltersModule } from './utils/filters/filters.module';
import { UtilsModule } from './utils/utils.module';

export function toastrConfigFactory(): any {
  return {
    timeOut: 6000,
    extendedTimeOut: 4000,
    preventDuplicates: true,
    maxOpened: 3,
    progressBar: true,
    closeButton: true,
  };
}

@NgModule({
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MikuMenuModule,
    ToastrModule.forRoot(toastrConfigFactory()),
    AppRoutingModule,
    UtilsModule,
    CoreModule,
    SecurityModule,
    NgSelectModule,
    FiltersModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMomentDateModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    LazyLoadImageModule,
    LazyLoadImageModule,
    BreadcrumbsModule,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  exports: [UtilsModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandlerService,
    },
    { provide: MAT_DATE_FORMATS, useValue: MATERIAL_MOMENT_DATE_FORMATS },
    { provide: LAZYLOAD_IMAGE_HOOKS, useClass: ScrollHooks },
  ],
})
export class AppModule {}
